import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { GlobalLoader, ProtectedRoute, PublicRoute } from '@/components';
import { USER_ROLES } from '@/constants/app';
import { DashboardLayout } from '@/components/layout';
import { LoginPage, NotFoundPage } from '@/pages';
import { DashboardPage } from '@/pages/dashboard';
import { ManageCompany } from '@/components/company';
import { ManageCustomer } from '@/components/customer';
import { ManageSupplier } from '@/components/supplier';
import { ManageMaterial } from '@/components/material';
import { ManagePurchaseOrder } from '@/components/purchaseOrder';
import { ManageEmployee } from '@/components/employee';
import { ProfilePage } from '@/pages/profile';
import { MaterialLogs } from '@/components/activityLog';
import { ManageStatusEnquiry } from '@/components/statusEnquiry';


export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<GlobalLoader />}>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        
        {/* Home - All authenticated users */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.EMPLOYEE, USER_ROLES.ADMIN, USER_ROLES.MANAGER, ]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
        </Route>

        {/* Companies - Admin and Manager only */}
        <Route
          path="/companies"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManageCompany />} />
        </Route>

        {/* Customers - Admin and Manager only */}
        <Route
          path="/customers"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManageCustomer />} />
        </Route>

        {/* Suppliers - Admin and Manager only */}
        <Route
          path="/suppliers"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManageSupplier />} />
        </Route>

        {/* Materials - Admin and Manager only */}
        <Route
          path="/materials"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManageMaterial />} />
        </Route>

        {/* Material Logs - Admin and Manager only */}
        <Route
          path="/material-logs"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<MaterialLogs />} />
        </Route>

        {/* Purchase Orders - Admin and Manager only */}
        <Route
          path="/purchase-orders"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.EMPLOYEE]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManagePurchaseOrder />} />
        </Route>

        {/* Employees - Admin and Manager only */}
        <Route
          path="/employees"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManageEmployee />} />
        </Route>

        {/* Status Enquiries - All authenticated users */}
        <Route
          path="/status-enquiries"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.EMPLOYEE, USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ManageStatusEnquiry />} />
        </Route>

        {/* Profile - All authenticated users */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.EMPLOYEE, USER_ROLES.ADMIN, USER_ROLES.MANAGER,]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ProfilePage />} />
        </Route>

        {/* Settings - Admin only */}
        {/* <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.EMPLOYEE, USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<div>Settings - Admin Only</div>} />
        </Route> */}

     

        {/* <Route
          path="/configuration/subject-configuration"
          element={
            <ProtectedRoute requiredRoles={[USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<SubjectConfiguration />} />
        </Route> */}

        {/* Default redirect */}
        <Route
          path="/"
          element={<Navigate to="/dashboard" replace />}
        />
        
        {/* 404 Page */}
        <Route
          path="*"
          element={<NotFoundPage />}
        />
      </Routes>
    </Suspense>
  );
};